import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 font-bold text-lg">
                51
              </div>
              <span className="font-heading text-xl text-foreground-950">吃瓜网</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              全网最新最热的吃瓜资讯平台。娱乐圈八卦、网红动态、社会热点，你想看的都在这里，每日更新，精彩不断。
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">
              热门分类
            </h4>
            <div className="flex flex-wrap gap-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-1.5 rounded-full text-xs font-medium bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">
              快捷入口
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#hot-today" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer">
                  今日热门
                </a>
              </li>
              <li>
                <a href="#latest" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer">
                  最新资讯
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">
              联系我们
            </h4>
            <div className="space-y-2 text-sm text-foreground-600">
              <p>合作邮箱：contact@51chigua.com</p>
              <p>广告投放：ad@51chigua.com</p>
              <p>内容投稿：submit@51chigua.com</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 51吃瓜网 保留所有权利。本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}